import vingrosana from '../images/vingrosana.jpeg';

// Masāžas — service list rendered in the "Jūsu veselībai un skaistumam piedāvājam" section.
// Each item: { title, badge?, image?, intro?, bullets?, outro?, prices: [{ label, value }] }
const masazas = [
  {
    title: 'Individuāla vingrošana',
    image: vingrosana,
    imageAlt: 'vingrošana',
    bullets: [
      'Dziļās muskulatūras attīstīšana',
      'Vispārēja ķermeņa korpusa stiprināšana',
      'Ķermeņa mobilitātes attīstīšana',
    ],
    prices: [
      { label: 'Individuāla vingrošana', value: '25 €' },
      { label: 'Vingrošana grupā (2 cilvēki)', value: '15 €' },
      { label: 'Vingrošana grupā (līdz 6 cilvēki)', value: '10 €' },
    ],
  },
  {
    title: 'Klasiskā masāža',
    intro:
      'Šī masāža tiek rekomendēta veseliem cilvēkiem, lai uzturētu labu pašsajūtu, kā arī dažādu slimību profilaksei. Masāža noder pie ļoti daudzām slimībām:',
    bullets: [
      'Muskuļu spazmām',
      'Dažādiem muskuļu, saišu un nervu bojājumiem un traumām',
      'Mugurkaula osteohondrozes',
      'Neiralģijas',
      'Skoliozes',
      'Migrēnas',
      'Hipertoniskās slimības',
    ],
    outro:
      'Masāžas mērķis – paātrināt bojātu audu dzīšanas procesus, novērst mugurkaula problēmas un nostiprināt tā muskulatūru. Paātrinot asins cirkulāciju un noņemot tūskas, atdzīvināt bronhu, zarnu trakta, žultsceļu darbību un pazemināt vai paaugstināt nervu sistēmas tonusu.',
    prices: [
      { label: 'Muguras masāža (apkakle, mugura, krusti)', value: '30 €' },
      { label: 'Apkakles zonas + galvas masāža', value: '30 €' },
      { label: 'Apkakles zonas masāža', value: '25 €' },
      { label: 'Kājas un sēžas daļa', value: '30 €' },
      { label: 'Visa ķermeņa masāža', value: '50 €' },
      { label: 'Campi masāža (apkakle, pleci, galva)', value: '35 €' },
    ],
  },
  {
    title: 'Medus masāža',
    prices: [
      { label: 'Vēders + mugura', value: '30 €' },
      { label: 'Visam ķermenim', value: '50 €' },
    ],
  },
  {
    title: 'Karsto akmeņu masāža',
    intro: 'Relaksējoša un atslabinoša masāža - baudījumus ķermenim un dvēselei!',
    prices: [
      { label: 'Mugura, apkakle', value: '35 €' },
      { label: 'Visam ķermenim', value: '55 €' },
    ],
  },
  {
    title: 'Sejas kopšana',
    intro:
      'Sejas ādas tīrīšana, masāža + dekoltē zonas masāža. Sejas kopšanas procedūru laikā tiek veikta netraumatiska sejas tīrīšana, lai atdalītu atmirušās šūnas, likvidētu komedonus, pinnes un novērstu daudz citu problēmu rašanos, uzturot ārēji svaigu izskatu. Regulāru procedūru rezultātā uzlabojas sejas krāsa, āda kļūst tvirta un atdzīvojas. Ja vēlamais efekts netiek sasniegts ar maskām un masāžām, to spēj panākt ar aparātiem, kas nostiprina saistaudus un baro šūnas, redzami izlīdzina sejas ādas grumbiņas un aizkavē jaunu veidošanos. Procedūrās tiek izmantotas plastificējošas aļģu maskas, šokolādes, porcelāna un mitrinošas maskas. Procedūra domāta, lai stimulētu asinsriti, vielmaiņu un uzlabotu ādas elastību. Efekts ir redzams tūlīt pēc procedūras, - sejas āda iegūst dzīvīguma un starojuma pievilcību.',
    prices: [
      { label: 'Sejas vakuummasāža + dekoltē masāža (pīlings, masāža, maskas)', value: '35 €' },
      { label: 'Ekspress masāža galvai 30 min', value: '25 €' },
    ],
  },
  {
    title: 'Vaksācija',
    intro:
      'Piedāvājam izvēlēties depilāciju ar vaskiem, kas veidoti no dabīgām vielām un ir īpaši paredzēti jūtīgai ādai. Procedūras veicam ar šķidro vasku.',
    prices: [
      { label: 'Roku vaksācija', value: '10-15 €' },
      { label: 'Padušu vaksācija', value: '5-8 €' },
      { label: 'Bikini zonas vaksācija', value: '12-25 €' },
      { label: 'Kāju vaksācija līdz celim', value: '10-15 €' },
      { label: 'Kājas visā garumā', value: '20-25 €' },
    ],
  },
];

export default masazas;
